import React, { Fragment, useState, useContext, useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import DriverListTable from "./DriverListTable";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import {
  driverFilterColumns,
  searchColumns,
} from "../../../Data/Driver/DriverListing";
import SharedDataContext from "../../../_helper/SharedData";
import { getUserRole, showAlert } from "../../../Services/Shared.service";
import SelectedFilter from "./SelectedFilter";
import {
  getDriverListCount,
  getDriverList,
  getDriverTableFilterData,
  getDriverTableSearchData,
} from "../../../Services/Driver.service";
import { useLocation } from "react-router";
import CreateDriver from "./CreateDriver";
import { Plus } from "react-feather";
import { Admin, OnboardingAgent } from "../../../Data/SideMenu/RouteMapping";

const DriverListing = () => {
  const location = useLocation();
  const { cityData, globalCityField, setShowApiLoader, setPageNumber } =
    useContext(SharedDataContext);

  const [driverData, setDriverData] = useState([]);

  const [paginationTotalRows, setPaginationTotalRows] = useState(0);

  const [pagination, setPagination] = useState(location.state?.pageNumber ? location.state.pageNumber : 0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [filterData, setFilterData] = useState(location.state?.filterdata?.length > 0 ? location.state?.filterdata : []);

  const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
  const [loader, setLoader] = useState(false);
  const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : "");

  const [createDriverModal, setCreateDriverModal] = useState(false);
  const toggleCreateDriverModal = () =>
    setCreateDriverModal(!createDriverModal);

  const [editId, setEditId] = useState("")

  const userRole = getUserRole()

  let columns = [];
  driverFilterColumns.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
        },
        label: element.name,
      });
    }
  });

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };
  const fetchDriverData = async ({ isSearchFilterPage }) => {
    const serviceCityId = globalCityField.value?.id || 0;
    const filterCityId = globalCityField.value?.id?.toString() || null;
    const obj = {
      page: pagination,
      size: rowsPerPage,
      serviceCityId: serviceCityId,
    };
    console.log(filterData, searchData, filterType, "filterType");
    if (filterData.length == 0 && !searchData) {
      setLoader(true);
      getDriverList(obj)
        .then((result) => {
          setDriverData(result.data.driverList);
          setPaginationTotalRows(result.data.count);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          setDriverData([]);
          showAlert("error", "Something went wrong");
        });
      // getDriverListCount().then((result) => {
      //   if (result.data) {
      //     setPaginationTotalRows(result.data);
      //   }
      // });
    } else if (filterData.length > 0 && filterType == "filter") {
      let body = [
        // {
        //   type: "Driver",
        // },
        {
          service_city: filterCityId,
        },
      ];
      filterData.forEach((element) => {
        body.push({
          column_name: element.column_name,
          value: element.values[0],
        });
      });
      setLoader(true);
      getDriverTableFilterData({ ...obj, page: isSearchFilterPage }, body)
        .then((result) => {
          if (result.data) {
            const data = result.data?.filterResponse || [];
            setDriverData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setDriverData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (searchData && filterType == "search") {
      let body = [
        // {
        //   type: "Driver",
        // },
        {
          service_city: filterCityId,
        },
        {
          column_names: searchColumns,
          value: searchData,
        },
      ];
      setLoader(true);
      getDriverTableSearchData(
        { ...obj, page: isSearchFilterPage },
        body
      )
        .then((result) => {
          if (result.data) {
            const data = result.data?.searchResponse || [];
            setDriverData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setDriverData([]);
          showAlert("error", "Something went wrong");
        });
    }
  };

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  useEffect(() => {
    if (filterData.length == 0 && filterType != "filter") return;
    fetchDriverData({ isSearchFilterPage: 0 });
  }, [filterData]);

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    fetchDriverData({ isSearchFilterPage: 0 });
  }, [searchData]);

  useEffect(() => {
    fetchDriverData({ isSearchFilterPage: pagination });
  }, [pagination, rowsPerPage, globalCityField.value]);

  console.log("edit id", editId)
  return (
    <Fragment>
      <Breadcrumbs
        parent="Driver"
        subParent="Driver Listing"
        mainTitle="Driver Listing"
        span2={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
          />
        }
        span1={
          userRole.some(
            (element) => element == Admin || element == OnboardingAgent
        ) ? <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: toggleCreateDriverModal }}>
            <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
          </Btn> : null
        }
        span3={
          <SearchTable
            setFilterType={setFilterType}
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
            placeholder={"Search with Phone No or Cab No"}
          />
        }
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
          {/* {filterData.length > 0 ? (
            <div className="save-filter">Save Filter</div>
          ) : (
            ""
          )} */}
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                <DriverListTable
                  driverData={driverData}
                  onChangePage={onChangePage}
                  paginationPerPage={rowsPerPage}
                  paginationTotalRows={paginationTotalRows}
                  onChangeRowsPerPage={onChangeRowsPerPage}
                  setShowApiLoader={setLoader}
                  globalCityField={globalCityField}
                  fetchDriverData={() => {
                    console.log("fetching driver data")
                    fetchDriverData({ isSearchFilterPage: pagination })
                  }}
                  pagination={pagination}
                  setPageNumber={setPageNumber}
                  pageNumber={
                    location.state?.pageNumber
                      ? location.state.pageNumber + 1
                      : 1
                  }
                  loader={loader}
                  filterData={filterData}
                  searchData={searchData}
                  setEditId={setEditId}
                  toggleCreateDriverModal={toggleCreateDriverModal}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <CreateDriver
        Large={createDriverModal}
        title={editId ? "Update Driver" : "Create Driver"}
        LargeModaltoggle={() => {
          setEditId("")
          fetchDriverData({ isSearchFilterPage: pagination });
          toggleCreateDriverModal()
        }}
        cityDataList={cityData}
        setShowApiLoader={setShowApiLoader}
        editId={editId}
      />
    </Fragment>
  );
};

export default DriverListing;
